(function () {
	let btn      = document.querySelector('.mobile__controls .btn');
	let menu     = document.querySelector('.topo__main');
	let active   = 'topo__main--shown';
	let expanded = false;

	btn.addEventListener('click', function(e) {
		e.preventDefault();

		if(!expanded) {
			menu.classList.add(active);
			document.body.classList.add(active);

			btn.setAttribute('aria-expanded', true);
			btn.classList.add('active');

			expanded = true;
		}else {
			menu.classList.add('hide');
			btn.classList.remove('active');

			btn.setAttribute('aria-expanded', false);

			expanded = false;
		}

		btn.blur();
	});

	menu.addEventListener('animationend', function() {
		if(menu.classList.contains('hide')) {

			menu.classList.remove('hide');
			menu.classList.remove(active);
			document.body.classList.remove(active);

		}
	});

})();
